(() => {
  const lists = document.querySelectorAll(".ep-story-timeline__list");
  if (!lists.length) return;

  let ticking = false;

  const update = () => {
    lists.forEach((list) => {
      const items = list.querySelectorAll(".ep-story-timeline__item");
      if (!items.length) {
        list.style.setProperty("--ep-timeline-line-height", "0px");
        list.style.setProperty("--ep-timeline-progress", "0px");
        return;
      }

      const first = items[0];
      const last = items[items.length - 1];
      let gap = 0;
      if (items.length > 1) {
        gap =
          items[1].offsetTop -
          items[0].offsetTop -
          items[0].offsetHeight;
        gap = Math.max(0, gap);
      }
      const styles = getComputedStyle(list);
      const dot =
        parseFloat(styles.getPropertyValue("--ep-timeline-dot")) || 0;
      const rect = list.getBoundingClientRect();
      const listTop = rect.top + window.scrollY;
      const startOffset = first.offsetTop - gap / 2 + dot / 2;
      const start = listTop + startOffset;
      const end = listTop + last.offsetTop + last.offsetHeight;
      const lineHeight = Math.max(0, end - start);
      const target = window.scrollY + window.innerHeight * 0.45;
      const rawProgress = Math.max(0, target - start);
      const progress = Math.min(lineHeight, Math.max(0, rawProgress));

      list.style.setProperty(
        "--ep-timeline-line-top",
        `${startOffset}px`
      );
      list.style.setProperty("--ep-timeline-line-height", `${lineHeight}px`);
      list.style.setProperty("--ep-timeline-progress", `${progress}px`);
    });
    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  };

  update();
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
  window.addEventListener("load", onScroll);
})();
